import dompurify from "dompurify";

const youtubeUrlRegex =
  /^https?:\/\/(?:www\.)?youtube(?:-nocookie)?\.com\/embed\/([a-zA-Z0-9_-]{11})/;

const config = {
  WHITELIST: {
    iframe: ["src", "allowfullscreen", "frameborder", "referrerpolicy"],
  },
  ADD_TAGS: ["iframe"],
  ADD_ATTR: ["allow", "autoplay", "target", "referrerpolicy"],
};

const parser = new DOMParser();

// Sanitiza rich text del CMS permitiendo iframes (embeds de YouTube),
// agregando referrerpolicy automáticamente cuando corresponde.
// Misma lógica que usaba template2/index.js (función allowIframe),
// extraída acá para reusarla también en pages/legados.
export const sanitizeRichText = (content) => {
  let clean = "";
  const doc = parser.parseFromString(content, "text/html");

  const iframes = doc.getElementsByTagName("iframe");

  for (let i = 0; i < iframes.length; i++) {
    const url = iframes[i].getAttribute("src");

    // Agregar referrerpolicy automáticamente a iframes de YouTube
    if (url && url.match(youtubeUrlRegex)) {
      if (!iframes[i].hasAttribute("referrerpolicy")) {
        iframes[i].setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
      }
    }
  }

  clean = dompurify.sanitize(doc.documentElement.innerHTML, config);
  return clean;
};

export default sanitizeRichText;
